//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import "@polymer/iron-ajax";

import "../../shared/CardFAQ";
import "./ModalFAQ.style";

class ModalFAQ extends PolymerElement {
  static get template() {
    return html`
      <style include="modal-faq-style"></style>
      <iron-ajax
        auto
        url="/api/general/webinars/faq"
        handle-as="json"
        on-response="handleResponse"
        debounce-duration="300">
      </iron-ajax>
      <div id="myModal" class$="modal [[handleModal(isActive)]]">
        <div class="modal-content">
          <div class="header">
            <h2>FAQ</h2>
            <span class="close" on-click="handleCloseModal">&times;</span>
          </div>
          <dom-repeat items="{{faqs}}" as="faq">
            <template>
              <card-faq title="{{faq.title}}" description="{{faq.content}}"></card-faq>
            <template>
          </dom-repeat>
          <div class="space"></div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      isActive: {
        type: Boolean,
        notify: true,
      },
      faqs: {
        type: Array,
        value: [],
      },
    };
  }

  handleCloseModal() {
    this.isActive = false;
  }

  handleModal(isActive) {
    return isActive ? "show" : "hide";
  }

  handleResponse(e, req) {
    const res = e.detail.response;
    this.faqs = res.data;
  }
}
customElements.define("modal-faq", ModalFAQ);
